import { Input } from '@iwoca/orion';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { TFormValues } from '../CheckoutLinkDebitCardForm';

export const BillingPostcodeField = ({
    formRegister,
    error,
    placeholder = 'e.g. N6 6NG'
}: {
    formRegister: UseFormRegister<TFormValues>;
    error?: FieldError;
    placeholder?: string;
}) => {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.billing_postcode_required',
        defaultMessage: 'Billing postcode is required'
    });

    return (
        <DebitCardFieldWrapper
            label={intl.formatMessage({
                id: '_.link_debit_card.billing_postcode',
                defaultMessage: 'Billing postcode'
            })}
            htmlFor="billingPostcode"
            error={error ? errorMessage : null}
        >
            <Input
                type="text"
                id="billingPostcode"
                placeholder={placeholder}
                className="fs-exclude"
                {...formRegister('billingPostcode', { required: true })}
            />
        </DebitCardFieldWrapper>
    );
};
